import { type ChangeEvent } from "react";
import { format } from "./format";

const SSN_PATTERN = /(\d{3})(\d{0,2})(\d{0,4})/;
const SSN_SEPARATOR = "-";

export const formatSSN = (event: ChangeEvent<HTMLInputElement>) => {
    return format(event, SSN_PATTERN, SSN_SEPARATOR);
};
